/* The replies beneath a note (decision 0671): indented under the note's own text, the toggle reading the count while folded. */
.thread {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  width: 100%;
}

/* 🔒 The foot is one line (decision 5493): Show more at the left, the replies glyph and its count at the right. */
.foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-2);
}

.toggle {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  margin-left: auto;
  padding: 0;
  border: 0;
  background: none;
  color: var(--text-muted);
  font-size: var(--font-size-small);
  cursor: pointer;
}

/* T2904: drawn into the end of the note's own last line, so it takes no margin to push it right. */
.toggleInline {
  margin-left: 0;
}

/* A folded note with its glyph in the text has nothing of its own to draw. */
.thread[data-note-bubble='inline'][data-note-thread-open='false'] {
  display: none;
}

.toggle:hover,
.toggle[aria-expanded='true'] {
  color: var(--navy-primary);
}

.toggle:focus-visible {
  outline: var(--focus-ring);
  outline-offset: var(--focus-ring-offset);
}

.replies {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  margin: 0;
  padding: 0 0 0 var(--space-3);
  border-left: var(--field-border-width) solid var(--tile-border);
  list-style: none;
}

.reply {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}

.replyHead {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-2);
}

.replyAuthor {
  font-size: var(--font-size-small);
  font-weight: var(--font-weight-semibold);
}

.replyWhen {
  font-size: var(--font-size-small);
  color: var(--text-muted);
}

.replyBody {
  font-size: var(--font-size-small);
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.remove {
  display: inline-flex;
  padding: 0;
  border: 0;
  background: none;
  color: var(--text-muted);
  cursor: pointer;
}

.compose {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-1);
  padding-left: var(--space-3);
}
